import script from "./allHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./allHistory.vue?vue&type=script&setup=true&lang=ts"

import "./allHistory.vue?vue&type=style&index=0&id=5f5f3644&scoped=true&lang=scss"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f5f3644"]])

export default __exports__